export const siteflowProduct = state => state.siteflowProduct;
